<template>
  <div id="crew-basic-info-card" class="vx-card px-10 py-4">
    <div class="flex overflow-hidden">
      <!-- 名前-ステータス コンテナ -->
      <div class="flex justify-between">
        <!-- 名前エリア -->
        <div class="flex flex-col w-64 justify-center gap-1">
          <!-- カナ -->
          <div
            v-if="nameKana"
            class="aisea-text-14-400-dark-gray m-0"
            style="overflow-wrap: break-word;"
          >
            {{ nameKana }}
          </div>
          <!-- 名前 -->
          <div
            class="name-text m-0"
            style="font-size: 20px; font-weight: 600; overflow-wrap: break-word;"
          >
            {{ name }}
          </div>
        </div>
        <!-- ステータス -->
        <div class="flex flex-col h-full">
          <div
            v-if="isEnrolled"
            class="flex justify-center items-center px-2 rounded"
            :style="{ backgroundColor: '#00BCD4', color: '#F2F2F2' }"
          >
            <div class="text-sm leading-5 whitespace-no-wrap">
              在籍中
            </div>
          </div>
          <div
            v-else
            class="flex justify-center items-center px-2 rounded"
            :style="{ backgroundColor: '#F2F2F2', color: '#626262' }"
          >
            <div class="text-sm leading-5 whitespace-no-wrap">
              退職済
            </div>
          </div>
        </div>
      </div>

      <div
        class="ml-8 mr-4 w-px "
        :style="{ backgroundColor: AISEA_COLOR.LIGHT_GRAY }"
      ></div>

      <!-- 情報グリッドエリア -->
      <div class="flex items-center w-full">
        <div class="flex flex-row">
          <div class="flex flex-col" style="min-width: 340px; flex: 1;">
            <!-- 社員区分 -->
            <div class="flex items-center py-1 px-4 gap-14">
              <div class="w-24 aisea-text-14-600-dark-gray leading-5">
                社員区分
              </div>
              <div class="aisea-text-16-400-dark-gray leading-6">
                {{ employmentStatusLabel }}
              </div>
            </div>
            <!-- 辞令職 -->
            <div class="flex items-center py-1 px-4 gap-14">
              <div class="w-24 aisea-text-14-600-dark-gray leading-5">
                辞令職
              </div>
              <div class="aisea-text-16-400-dark-gray leading-6">
                {{ appointedRole ? appointedRole : "-" }}
              </div>
            </div>
          </div>
          <div class="flex flex-col" style="min-width: 340px; flex: 1;">
            <!-- 所属企業 -->
            <div class="flex items-center py-1 px-4 gap-14">
              <div class="w-24 aisea-text-14-600-dark-gray leading-5">
                所属企業
              </div>
              <div class="aisea-text-16-400-dark-gray leading-6">
                {{ companyName ? companyName : "-" }}
              </div>
            </div>
            <!-- 社員番号 -->
            <div class="flex items-center py-1 px-4 gap-14">
              <div class="w-24 aisea-text-14-600-dark-gray leading-5">
                社員番号
              </div>
              <div class="aisea-text-16-400-dark-gray leading-6">
                {{ employeeNumber ? employeeNumber : "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { getEmploymentStatusLabel } from "../constants/EmploymentStatus.js";

export default {
  name: "CrewBasicInfoCard",

  mixins: [ColorMixin],

  props: {
    /**
     * 船員の氏名
     * @type {String}
     * @required
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * 船員のカナ表記
     * @type {String}
     * @optional
     */
    nameKana: {
      type: String,
      default: "",
    },

    /**
     * 在籍中かどうかのフラグ
     * @type {Boolean}
     * @required
     */
    isEnrolled: {
      type: Boolean,
      required: true,
    },

    /**
     * 辞令職
     * @type {String}
     * @optional
     */
    appointedRole: {
      type: String,
      default: "",
    },

    /**
     * 社員区分
     * @type {String}
     * @optional
     */
    employmentStatus: {
      type: String,
      default: "",
    },

    /**
     * 所属企業名
     * @type {String}
     * @optional
     */
    companyName: {
      type: String,
      default: "",
    },

    /**
     * 社員番号
     * @type {String}
     * @optional
     */
    employeeNumber: {
      type: String,
      default: "",
    },
  },
  computed: {
    employmentStatusLabel() {
      if (!this.employmentStatus) {
        return "-";
      }
      return getEmploymentStatusLabel(this.employmentStatus);
    },
  },
};
</script>
